module.exports = __webpack_public_path__ + "public/img/Bahasa Inggris Untuk Karyawan Perkantoran.215c9fd7.png";